import { useQuery } from '@apollo/client'
import { useNavigate, useOutletContext } from 'react-router'

import { queries } from '../../graphql'
import { AddEmailForm, ChangeEmailForm, ChangePasswordForm, DeactivateEmailForm } from '.'
import { Button, CardBox, Stack, Text } from '../../components'

export function SecuritySettingsLayout() {
  const navigate = useNavigate()
  const { data: { me } = {}, refetch } = useQuery(queries.user.me)
  const { donorFundId } = useOutletContext()
  const { email: primaryEmail, userEmails, profile } = me ?? {}
  const address = me?.funds?.find((f) => f.id === donorFundId)?.fundProfile?.address
  const isCharityUser = (me?.charityUsers || []).length > 0
  const firstLogin = !address && !isCharityUser
  const availableEmails = userEmails.filter((item) => item.active)

  return (
    <Stack>
      {firstLogin ? (
        <CardBox>
          <Stack>
            <Text.Body>
              You must update your profile with your address and phone number in order to complete your registration.
            </Text.Body>
            <Button onClick={() => navigate('..')}>Go to Update Profile</Button>
          </Stack>
        </CardBox>
      ) : (
        <>
          <CardBox>
            <AddEmailForm />
          </CardBox>
          {availableEmails.length > 1 && (
            <>
              <CardBox>
                <ChangeEmailForm currentEmail={primaryEmail} availableEmails={availableEmails} />
              </CardBox>
              <CardBox>
                <DeactivateEmailForm
                  currentEmail={primaryEmail}
                  availableEmails={availableEmails}
                  refetchEmails={refetch}
                />
              </CardBox>
            </>
          )}
          <CardBox>
            <ChangePasswordForm />
          </CardBox>
        </>
      )}
    </Stack>
  )
}
